import { render, staticRenderFns } from "./SongList.vue?vue&type=template&id=e4af2560&scoped=true&"
import script from "./SongList.vue?vue&type=script&lang=js&"
export * from "./SongList.vue?vue&type=script&lang=js&"
import style0 from "./SongList.vue?vue&type=style&index=0&id=e4af2560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4af2560",
  null
  
)

export default component.exports